import { MsalService } from '@azure/msal-angular';

import { AuthService } from './authService.service';
import { CurrentUserContextService } from './current-user-context.service';
import { MsalBootstrapService } from './msal-bootstrap.service';

export function initializePortalAuth(
  msalBootstrapService: MsalBootstrapService,
  msalService: MsalService,
  authService: AuthService,
  currentUserContext: CurrentUserContextService
): () => Promise<void> {
  return () => {
    currentUserContext.initialize();
    return msalBootstrapService.ensureReady(msalService, authService).catch(() => undefined);
  };
}
